<template>
    <footer class="myFooter">
        <div class="indexMenuBox">
            <div class="tc mt8 footerMenu" v-cur="{index: index, bottomBarIndex: app.bottomBarIndex, curStyle: curStyle}" v-for="(item, index) in barList" :key="index" v-on:click='toPage(index, item.url)'>
                <template v-if="item.img !== ''">
                    <p :class="item.class"><img :src="item.img" /></p>
                </template>
                <template v-else>
                    <p class="lh16"><em :class="item.class"></em></p>
                </template>
                <p class="f10 lh18">{{item.name}}</p>
            </div>
        </div>
    </footer>
</template>

<script>
    import {config} from '../../libs/config';
    import {mapMutations, mapState} from 'vuex';

    export default {
        name: 'BottomBar',
        props: {
            styleName: {
                type: String,
                default: 'main'
            }
        },
        data() {
            return {
                barList: []
            }
        },
        created() {
            this.barList = config.BOTTOM_BAR_LIST;
        },
        computed: {
            ...mapState(['app']),
            curStyle() {
                if (this.styleName === 'main_b') {
                    return 'color_red';
                } else if (this.styleName === 'main_c') {
                    return 'color_green';
                } else {
                    return 'color_use';
                }
            }
        },
        directives: {
            'cur': function (el, binding) {
                if (binding.value.index === binding.value.bottomBarIndex) {
                    el.classList.add(binding.value.curStyle)
                } else {
                    el.classList.remove(binding.value.curStyle)
                }
            }
        },
        methods: {
            ...mapMutations([
                'setBottomBarIndex'
            ]),
            toPage: function (index, url) {
                let self = this;
                self.setBottomBarIndex(index);
                self.$router.push({name: url})
            }
        }
    }
</script>

<style scoped>

</style>
